import React from "react";
import { FaFacebookF, FaInstagram, FaXTwitter } from "react-icons/fa6";
import { MdEmail, MdPhone } from "react-icons/md";
import logo from "../assets/logo.png"; // Replace with your actual logo path

const Footer = () => {
  return (
    <footer id="contact" className="bg-[#E2F1F4] text-center py-10 px-4">
      {/* Logo */}
      <div className="flex justify-center mb-4">
        <a href="#home">
          <img src={logo} alt="Eye Care Optical" className="h-20 cursor-pointer" />
        </a>
      </div>

      {/* Description */}
      <p className="text-[#343434] font-manrope max-w-xl mx-auto mb-6 text-sm">
        We know your eyes deserve the best! It’s time to visit us and examine your
        eyes with more precision and care.
      </p>

      {/* Contact Details */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-medium text-[#343434] mb-6">
        <div className="flex items-center gap-2">
          <MdPhone className="text-[#3471B8] font-manrope text-medium text-[16px]" />
          <span>+250 788867121</span>
        </div>
        <div className="flex items-center gap-2">
          <MdEmail className="text-[#3471B8] font-manrope text-medium text-[16px]" />
          <span>eyecareoptical.rwanda@yahoo.com</span>
        </div>
      </div>

      {/* Social Icons */}
      <div className="flex justify-center items-center gap-6 text-[#3471B8]">
        <a href="https://www.instagram.com/eyecare_optical_rwanda" aria-label="Instagram"><FaInstagram className="text-xl" /></a>
        <a href="https://www.facebook.com/share/19N13pXaF2/" aria-label="Facebook"><FaFacebookF className="text-xl" /></a>
        <a href="#" aria-label="X"><FaXTwitter className="text-xl" /></a>
      </div>
    </footer>
  );
};

export default Footer;
